<template>
  <div id="app">
    <div class="header" v-if="pathName !== '微沙盘'">
      <zh-header id="homeHeader" :class="homeHeaderFixed?'homeHeaderFixed':''" />
    </div>
    <div class="app-con">
      <router-view />
    </div>
    <zh-footer v-if="pathName !== '微沙盘'"/>
    <zh-drainage v-if="pathName !== '微沙盘'"/>
    <back-to-top v-if="pathName !== '微沙盘'" :visibility-height="300" :back-position="50" transition-name="fade"/>
  </div>
</template>
<script>
import ZhHeader from "@/components/ZhHeader.vue"
import ZhFooter from "@/components/ZhFooter.vue"
import zhDrainage from "@/components/zhDrainage.vue"
import BackToTop from '@/components/BackToTop.vue'
export default {
  name: "App",
  components: { ZhHeader, ZhFooter, zhDrainage, BackToTop },
  data () {
    return {
      offsetTop: 0,
      offsetHeight: 0,
      homeHeaderFixed: 0,
      pathName: ''
    }
  },
  watch: {
    '$route.path' () {
      this.pathName = this.$route.name
    },
  },
  mounted(){
    this.pathName = this.$route.name
    this.$nextTick(() => {
      // 获取吸顶元素的dom
      let homeHeader = document.getElementById("homeHeader");
      // 吸顶元素到top的距离
      this.offsetTop = homeHeader.offsetTop;
      // 元素自身的高度
      this.offsetHeight = homeHeader.offsetHeight;

       // 监听滚动条
       window.addEventListener("scroll", this.throttle(this.handleScroll,100));
    });
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll,100);
  },
  methods: {
    throttle (fn,delay) {
      let open = true;
      return function() {
        if (open == true) {
          open = false;
          setTimeout(() => {
              fn();
              open = true;
          }, delay);
        }
      };
    },
    handleScroll() {
      // 得到页面滚动的距离
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // 判断页面滚动的距离是否大于吸顶元素的位置
      this.homeHeaderFixed = scrollTop
    },
  }
};
</script>
<style lang="scss">
.header {
  height:80px;
  width: 100%;
}
.app-con {
  // min-height: 1000px;
  width: 100%;
  margin: 0 auto;
}
.homeHeaderFixed {
  position: fixed;
  width: 100%;
  top: 0px;
  z-index: 1001;
}
</style>
